
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { DomainModel } from 'models/generated/Distribution.Api.Models.Domain';
import { DnsRecordsResponseModel } from 'models/generated/Distribution.Api.Models.DnsRecordsResponse';
import { DomainRenewalInfoModel } from 'models/generated/Distribution.Api.Models.DomainRenewalInfo';


const _distribution_DomainControllerHelper = new Map<string, Object>();
_distribution_DomainControllerHelper.set('GetDomain', DomainModel);
_distribution_DomainControllerHelper.set('GetDomainsByName', DomainModel);
_distribution_DomainControllerHelper.set('GetDomains', DomainModel);
_distribution_DomainControllerHelper.set('SearchDomains', DomainModel);
_distribution_DomainControllerHelper.set('GetDnsRecords', DnsRecordsResponseModel);
_distribution_DomainControllerHelper.set('CheckExpiringDomainPlans', DomainModel);
_distribution_DomainControllerHelper.set('CheckAwaitingDomains', DomainModel);
_distribution_DomainControllerHelper.set('GetDomainRenewalInfo', DomainRenewalInfoModel);


export const distribution_DomainControllerHelper = _distribution_DomainControllerHelper;

